export default __webpack_public_path__ + "static/media/13 A SU IMAGEN Y SEMEJANZA.25d43971.png";